import d from "./design-system.es65.js";
import { resolveComponent as h, openBlock as p, createBlock as c, withCtx as r, renderSlot as l } from "vue";
import b from "./design-system.es116.js";
import f from "./design-system.es128.js";
import { AsYouType as u } from "./design-system.es308.js";
import { parsePhoneNumberWithError as N } from "./design-system.es309.js";
const y = {
  name: "DsPhoneInput",
  components: {
    InputField: d
  },
  props: {
    /**
     * Label to render above the phone field when active
     */
    label: String,
    /**
     * HTML input element name
     */
    name: {
      type: String,
      default: "phone"
    },
    /**
     * Country to format the phone input with
     */
    country: {
      type: String,
      default: "US"
    },
    /**
     * Controls visualization of rendering form validation error states
     */
    submitted: Boolean,
    /**
     * Required field for validation purposes
     */
    required: Boolean,
    /**
     * The value of the phone number
     */
    modelValue: [String, Number],
    /**
     * Forces invalid form field
     */
    invalid: Boolean,
    /**
     * Prevent user from typing in the input
     */
    readonly: Boolean,
    /**
     * Control whether you allow users to have the ability to autofill/autocomplete this input from things like Google
     */
    autocomplete: {
      type: [Boolean, String],
      default: !1
    }
  },
  emits: [
    "blur",
    "update:modelValue"
  ],
  setup() {
    return { i18n: b() };
  },
  data() {
    return {
      phoneNumber: this.modelValue,
      valid: !0
    };
  },
  computed: {
    isInvalid() {
      return !this.valid || this.invalid;
    }
  },
  watch: {
    phoneNumber(e) {
      e !== this.modelValue && this.$emit("update:modelValue", this.phoneNumber ? e : ""), this.checkIsValid();
    },
    modelValue(e) {
      e || (this.phoneNumber = ""), e !== this.phoneNumber && (this.phoneNumber = e);
    }
  },
  mounted() {
    this.load();
  },
  beforeUnmount() {
    this.phoneNumber = null;
  },
  methods: {
    updatePhoneNumber() {
      this.phoneNumber = new u(this.country).input(this.phoneNumber), this.$emit("blur"), this.checkIsValid();
    },
    load() {
      let e = this.modelValue;
      if (this.modelValue) {
        const t = N(this.modelValue, this.country);
        this.country === (t == null ? void 0 : t.country) && (e = t.formatNational());
      }
      e && (this.phoneNumber = new u(this.country).input(e)), this.checkIsValid();
    },
    checkIsValid() {
      if (!this.phoneNumber) {
        this.valid = !this.required;
        return;
      }
      this.valid = !0;
    }
  }
};
function V(e, t, o, a, n, i) {
  const m = h("InputField");
  return p(), c(m, {
    ref: "input",
    modelValue: n.phoneNumber,
    "onUpdate:modelValue": t[0] || (t[0] = (s) => n.phoneNumber = s),
    class: "phone-input-field",
    type: "tel",
    name: o.name,
    label: o.label || a.i18n.messages["phone.input.label"],
    invalid: i.isInvalid,
    maxlength: 30,
    submitted: o.submitted,
    required: o.required,
    readonly: o.readonly,
    autocomplete: o.autocomplete,
    onBlur: i.updatePhoneNumber
  }, {
    error: r(() => [
      l(e.$slots, "error")
    ]),
    help: r(() => [
      l(e.$slots, "help")
    ]),
    _: 3
  }, 8, ["modelValue", "name", "label", "invalid", "submitted", "required", "readonly", "autocomplete", "onBlur"]);
}
const k = /* @__PURE__ */ f(y, [["render", V]]);
export {
  k as default
};
//# sourceMappingURL=design-system.es86.js.map
